import React from 'react';
import ReactECharts from 'echarts-for-react';
import { format, subMonths, addMonths, startOfMonth, endOfMonth, isWithinInterval } from 'date-fns';

const OccupancyChart = ({ properties }) => {
  // Generate a 6-month window (3 months back, today, 2 months forward)
  const months = [];
  for (let i = -3; i <= 2; i++) {
    months.push(addMonths(new Date(), i));
  }

  const data = months.map(monthDate => {
    const monthStart = startOfMonth(monthDate);
    const monthEnd = endOfMonth(monthDate);
    
    const occupiedCount = properties.filter(p => {
      if (!p.leaseStart || !p.leaseEnd) return false;
      const start = new Date(p.leaseStart);
      const end = new Date(p.leaseEnd);
      // Check if the lease overlaps with this month
      return (start <= monthEnd && end >= monthStart);
    }).length;

    const percentage = properties.length > 0 
      ? Math.round((occupiedCount / properties.length) * 100) 
      : 0;

    return {
      month: format(monthDate, 'MMM yyyy'),
      percentage
    };
  });

  const option = {
    tooltip: {
      trigger: 'axis',
      formatter: '{b}: {c}% Occupancy',
      backgroundColor: '#fff',
      borderWidth: 0,
      textStyle: { color: '#374151' },
      extraCssText: 'box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);'
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      top: '10%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: data.map(d => d.month),
      axisLine: { lineStyle: { color: '#E5E7EB' } },
      axisLabel: { color: '#6B7280', fontSize: 11 }
    },
    yAxis: {
      type: 'value',
      max: 100,
      axisLabel: { formatter: '{value}%', color: '#6B7280' },
      splitLine: { lineStyle: { type: 'dashed', color: '#F3F4F6' } }
    },
    series: [
      {
        name: 'Occupancy',
        type: 'line',
        smooth: true,
        data: data.map(d => d.percentage),
        symbolSize: 8,
        itemStyle: { color: '#4F46E5' },
        lineStyle: { width: 3, color: '#4F46E5' },
        areaStyle: {
          color: {
            type: 'linear',
            x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [
              { offset: 0, color: 'rgba(79, 70, 229, 0.2)' },
              { offset: 1, color: 'rgba(79, 70, 229, 0)' }
            ]
          }
        }
      }
    ]
  };

  return <ReactECharts option={option} style={{ height: '300px' }} />;
};

export default OccupancyChart;